export default __webpack_public_path__ + "static/B0097-3045be58255cea92ac086e224d79e7de.png";